import { render, staticRenderFns } from "./CandidateContactChatForm.vue?vue&type=template&id=48cd2a3f&scoped=true&"
import script from "./CandidateContactChatForm.vue?vue&type=script&lang=js&"
export * from "./CandidateContactChatForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateContactChatForm.vue?vue&type=style&index=0&id=48cd2a3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd2a3f",
  null
  
)

/* custom blocks */
import block0 from "./CandidateContactChatForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CandidateContactChatForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VCheckbox,VProgressCircular})
